import * as d3 from 'd3-selection'
import {LEVITATED_OFFSET} from '../../wob'

export default function (canvas) {
  // Adds the svg for holding connectors

  // Wrap the `svg` in a div that has relative positioning. This is needed
  // for a safari bug with mouse events not working correctly on `path` elements
  // See https://github.com/SpiderStrategies/Scoreboard/issues/30746
  const container = d3.select(canvas.el)
                      .insert('div', ':first-child')
                      .attr('class', 'relative-connectors-container')
  const svg = container.append('svg')
                       .attr('class', 'connectors-container')
                       .style('z-index', LEVITATED_OFFSET - 1)

  svg.append('defs')
       .append('symbol')
       .attr('id', 'connector-settings-icon')
       .attr('viewBox', '0 0 100 100')
       .append('path')
         .attr('d', 'M97.4 41l-14.9-2.7c-1.4-.3-2-1.5-1.1-2.7L90 22.9c.8-1.2.6-3.1-.4-4.1l-8.2-8.2c-1-1-2.9-1.2-4.1-.4l-12.7 8.6c-1.2.8-2.4.3-2.7-1.1L59 2.6C58.7 1.2 57.3 0 55.8 0H44.2c-1.5 0-2.9 1.2-3.2 2.6l-2.7 14.9c-.3 1.4-1.5 2-2.7 1.1L22.9 10c-1.2-.8-3.1-.6-4.1.4l-8.2 8.2c-1 1-1.2 2.9-.4 4.1l8.6 12.7c.8 1.2.3 2.4-1.1 2.7L2.6 41c-1.4.3-2.6 1.7-2.6 3.2v11.6c0 1.5 1.2 2.9 2.6 3.2l14.9 2.7c1.4.3 2 1.5 1.1 2.7L10 77.1c-.8 1.2-.6 3.1.4 4.1l8.2 8.2c1 1 2.9 1.2 4.1.4l12.7-8.6c1.2-.8 2.4-.3 2.7 1.1L41 97.4c.3 1.4 1.7 2.6 3.2 2.6h11.6c1.5 0 2.9-1.2 3.2-2.6l2.7-14.9c.3-1.4 1.5-2 2.7-1.1L77.1 90c1.2.8 3.1.6 4.1-.4l8.2-8.2c1-1 1.2-2.9.4-4.1l-8.6-12.7c-.8-1.2-.3-2.4 1.1-2.7L97.4 59c1.4-.3 2.6-1.7 2.6-3.2V44.2c0-1.5-1.2-2.9-2.6-3.2zM50 68.1C40 68.1 31.9 60 31.9 50S40 32 50 32s18.1 8.1 18.1 18S60 68.1 50 68.1z')

  return svg
}
